import React from "react";
import { Link } from "react-router-dom";
import { clearBuilderReturn, readBuilderReturn } from "../events/builder/state/builderReturn";

/** Shown on integration screens when the user arrived from the event builder. */
const BuilderReturnBar = () => {
  const back = readBuilderReturn();
  if (!back) return null;
  return (
    <div className="px-3 pt-3">
      <Link to={back} className="btn btn-primary" onClick={clearBuilderReturn}>
        Back to event builder
      </Link>
    </div>
  );
};

export default BuilderReturnBar;
